<template>
    <div class="resumo-lateral" @click="aberto = !aberto">
        <g-card
            class="g-card-resumo-fechado"
            altura="96%"
            largura="50px"
            corCabecalho="#4F2C19"
            paddingFiltro="0"
            v-if="!aberto"
        >
            <template #cabecalho>
                <div class="container-icone-resumo">
                    <i class="pi pi-angle-double-left cabecalho-fechado"></i>
                </div>
            </template>
           <div class="titulo-resumo-fechado">{{titulofechado}}</div>
        </g-card>

        <g-card
            class="g-card-resumo-aberto"
            altura="96%"
            largura="25vw"
            corCabecalho="#4F2C19"
            v-if="aberto"
        >
        <!-- resumo-lateral -->
            <template #cabecalho>
                <div class="alinhar">

                <div class="cabecalho-aberto pi pi-angle-double-right "></div>
                <div class="titulo-resumo-aberto">{{tituloaberto}}</div>
                </div>

            </template>

            <slot></slot>
        </g-card>
    </div>
</template>

<script>
import gmenulateral from './g-card-resumo.js'
export default gmenulateral
</script>

<style scoped>

.container-icone-resumo{
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: red; */
}

.alinhar{
    display: flex;
}

/*
.resumo-lateral{
    RESUMO LATERAL DESATIVADO TEMPORARIAMENTE
    NÃO REMOVER DISPLAY NONE
    display: none !important;
}
*/

/* .resumo-lateral{
    margin-top: 15px;
    margin-bottom:10px;
} */

.card-menu{
    background-color: black;
}

.cabecalho-aberto{
    height: 32px;
    width: 32px;
    color: white;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 20px;
}

.cabecalho-fechado{
    /* height: 32px;
    width: 32px; */
    color: white;
    /* align-items: center; */
    font-size: 20px;

}

.titulo-resumo-aberto{
    color: white;
    font-family: 'MontSerrat';
    font-size: 20px;
}

.titulo-resumo-fechado{
    display: flex;
    writing-mode: vertical-rl;
    color: #4F2C19;
    font-family: 'MontSerrat';
    font-size: 20px;
    padding-top: 10px;
}
</style>
